
import { useNavigate } from 'react-router-dom';
import { useUserRoles } from '@/hooks/useUserRoles';
import { useState, useEffect } from 'react';
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { AdminMetrics } from '@/components/admin/AdminMetrics';
import { AdminQuickLinks } from '@/components/admin/dashboard/AdminQuickLinks';
import AdminLayout from '@/components/layout/AdminLayout';

export default function AdminDashboard() {
  const [userId, setUserId] = useState<string | null>(null);
  const navigate = useNavigate();
  const { role, loading } = useUserRoles(userId);
  const { toast } = useToast();

  useEffect(() => {
    const checkSession = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error("Session error:", error);
          navigate("/auth");
          return;
        }

        if (!session) {
          console.log("No active session");
          navigate("/auth");
          return;
        }

        console.log("Setting user ID:", session.user.id);
        setUserId(session.user.id);
      } catch (error) {
        console.error("Error checking session:", error);
        toast({
          variant: "destructive",
          title: "Error",
          description: "An unexpected error occurred. Please try again."
        });
      }
    };

    checkSession();
  }, [navigate, toast]);

  if (loading || !userId) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  if (role !== 'admin' && role !== 'producer') {
    return (
      <div className="container mx-auto py-16 px-4 text-center">
        <h1 className="text-3xl font-bold mb-6">Access Denied</h1>
        <p className="mb-6">You do not have permission to access the admin dashboard.</p>
        <button
          onClick={() => navigate('/')}
          className="bg-primary text-white px-4 py-2 rounded"
        >
          Return to Home
        </button>
      </div>
    );
  }

  return (
    <AdminLayout title="Insurance Admin Portal" showSidebar={false}>
      <div className="space-y-8">
        <AdminQuickLinks />
        <AdminMetrics />
      </div>
    </AdminLayout>
  );
};
